/** 校验原始公斤数，避免输入控件自动取整或截断后误提交；允许0，最多9位整数、3位小数。 */
export function isValidExpressWeight(value: unknown): boolean {
  return (typeof value === 'string' || typeof value === 'number') &&
    /^\d{1,9}(\.\d{1,3})?$/.test(String(value));
}
